const categories = [
    {
        id: 1,
        url:'/tops',
        category_name: "TOPS",
        thumb: "https://cdn.shopify.com/s/files/1/0845/0641/files/T_Shirt_1024x1024_crop_center.png?v=1649542057"
    },
    {
        id: 2,
        url:'/bottoms',
        category_name: "BOTTOMS",
        thumb: "https://cdn.shopify.com/s/files/1/0845/0641/files/Pants_3b68dd40-4c25-4e5a-bafd-0b7e32efaf7e_1024x1024_crop_center.png?v=1649542057"
    },
    {
        id: 3,
        url:'/women',
        category_name: "WOMEN",
        thumb: "https://cdn.shopify.com/s/files/1/0845/0641/files/Women_1024x1024_crop_center.png?v=1649542057"
    },
    {
        id: 4,
        url:'/kids',
        category_name: "KIDS",
        thumb: "https://cdn.shopify.com/s/files/1/0845/0641/files/Kids_1024x1024_crop_center.png?v=1649542057"
    },
    {
        id: 5,
        url:'/accessories',
        category_name: "ACCESSORIES",
        thumb: "https://cdn.shopify.com/s/files/1/0845/0641/files/Accessories_1024x1024_crop_center.png?v=1649542057"
    },
]
export default categories;